import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.secondary,
        padding: 0,
        width: '100%'
    },
    value: {
        lineHeight: '20px'
    },
    compact: {
        width: '60px'
    },
    strokeContainer: {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around'
    },
    stroke: {
        width: '70%',
        content: '\"\"',
        display: 'inline-block',
        background: theme.palette.text.secondary
    }
}))

export default useStyles